import React from 'react'
import { View } from 'react-native'
import PropTypes from 'prop-types'

import { DatePicker as MaterialDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import { ThemeProvider } from '@material-ui/styles'
import { createMuiTheme } from '@material-ui/core'
import { useTheme } from '../../theming/ThemeProvider'
import MomentUtils from '@date-io/moment'
import Input from '../Input'

const DatePicker = (props) => {
  const {
    name, label, value, onChange, placeholder, error, disablePast
  } = props

  const { theme } = useTheme()

  const defaultMaterialTheme = () =>
    createMuiTheme({
      palette: {
        primary: {
          main: theme.BUNKER
        },
        secondary: {
          main: theme.BUNKER
        },
        text: {
          primary: theme.BUNKER,
          disabled: theme.BUNKER
        }
      }
    })

  return (
    <View>
      <ThemeProvider theme={defaultMaterialTheme()}>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <MaterialDatePicker
            autoOk
            disablePast={disablePast}
            disableToolbar
            variant='inline'
            inputVariant='outlined'
            label={label}
            format='MM/DD/YYYY'
            value={value || null}
            placeholder={placeholder}
            onChange={date => onChange(name, date)}
            TextFieldComponent={Input}
            letfIcon='Calendar'
            error={error}
          />
        </MuiPickersUtilsProvider>
      </ThemeProvider>
    </View>
  )
}

DatePicker.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.any,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  error: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool
  ]),
  disablePast: PropTypes.bool
}

DatePicker.defaultProps = {
  name: '',
  label: '',
  value: null,
  placeholder: '',
  style: null,
  onChange: () => {},
  error: false
}

export default DatePicker
